import { MinzeElement, Attrs, Reactive, EventListeners } from 'minze'

export interface LvcHandDrawnBox {
  variant: string
  borderColor: string
  bgColor: string
  bgFromColor: string
  bgToColor: string
  hoverBorderColor: string
  hoverBgColor: string
  hoverBgFromColor: string
  hoverBgToColor: string
}

export class LvcHandDrawnBox extends MinzeElement {
  attrs: Attrs = [
    ['variant', 'box1'],
    ['borderColor', '#1E007D'],
    ['bgColor', '#DCFFD7'],
    ['bgFromColor', null],
    ['bgToColor', null],
    ['hoverBorderColor', null],
    ['hoverBgColor', null],
    ['hoverBgFromColor', null],
    ['hoverBgToColor', null],
  ]
  reactive: Reactive = [
    ['data', {}],
    ['isHover', false],
  ]

  static observedAttributes = [
    'variant',
    'borderColor',
    'bgColor',
    'bgFromColor',
    'bgToColor',
    'hoverBorderColor',
    'hoverBgColor',
    'hoverBgFromColor',
    'hoverBgToColor',
  ]

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (
      name === 'variant' ||
      name === 'borderColor' ||
      name === 'bgColor' ||
      name === 'bgFromColor' ||
      name === 'bgToColor' ||
      name === 'hoverBorderColor' ||
      name === 'hoverBgColor' ||
      name === 'hoverBgFromColor' ||
      name === 'hoverBgToColor'
    ) {
      this.data = {
        borderColor: this.borderColor,
        bgColor: this.bgColor,
        bgFromColor: this.bgFromColor,
        bgToColor: this.bgToColor,
        hoverBorderColor: this.hoverBorderColor,
        hoverBgColor: this.hoverBgColor,
        hoverBgFromColor: this.hoverBgFromColor,
        hoverBgToColor: this.hoverBgToColor,
      }
    }
    this.rerender()
  }

  get inject() {
    return `inject=${JSON.stringify(this.data)}`
  }

  setHoverState = (state: boolean) => {
    if (
      this.hoverBorderColor ||
      this.hoverBgColor ||
      this.hoverBgFromColor ||
      this.hoverBgToColor
    ) {
      this.isHover = state
    }
  }

  /* onReactive () {
    this.data = {
      borderColor: this.borderColor,
      bgColor: this.bgColor,
      bgFromColor: this.bgFromColor,
      bgToColor: this.bgToColor,
      hoverBorderColor: this.hoverBorderColor,
      hoverBgColor: this.hoverBgColor,
      hoverBgFromColor: this.hoverBgFromColor,
      hoverBgToColor: this.hoverBgToColor,
    };
    this.rerender()

  } */

  renderSvg = () => {
    switch (this.variant) {
      case 'box1':
        return `<lvc-hand-drawn-box1 ${this.inject}></lvc-hand-drawn-box1>`
      case 'box2':
        return `<lvc-hand-drawn-box2 ${this.inject}></lvc-hand-drawn-box2>`
      case 'button1':
        return `<lvc-hand-drawn-button1 ${this.inject}></lvc-hand-drawn-button1>`
      case 'button2':
        return `<lvc-hand-drawn-button2 ${this.inject}></lvc-hand-drawn-button2>`
      default:
        return `<lvc-hand-drawn-box1 ${this.inject}></lvc-hand-drawn-box1>`
    }
  }

  html = () => `
    <div id="hand-drawn-box" class="hand-drawn-box ${this.isHover ? 'hover' : ''}">
      <div class="hand-drawn-box-background">
        ${this.renderSvg()}
      </div>
      <div class="hand-drawn-box-content">
        <!-- Content -->
        <slot></slot>
      </div>
    </div>
  `

  eventListeners: EventListeners = [
    ['#hand-drawn-box', 'mouseover', () => this.setHoverState(true)],
    ['#hand-drawn-box', 'mouseout', () => this.setHoverState(false)],
  ]

  css = () => `
    :host {}

    .hand-drawn-box {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 10px;
    }

    .hand-drawn-box-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .hand-drawn-box-background:before {
      content: '';
      position: absolute;
      top: 10px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background: linear-gradient(to right, ${this.bgFromColor || this.bgColor}, ${this.bgToColor || this.bgColor});
    }

    .hand-drawn-box:hover .hand-drawn-box-background:before {
      background-image: linear-gradient(to right, ${this.hoverBgFromColor || this.hoverBgColor || this.bgFromColor || this.bgColor}, ${this.hoverBgToColor || this.hoverBgColor || this.bgToColor || this.bgColor});
    }

    .hand-drawn-box-content {
      position: relative;
    }

    ::part(border-top-left),
    ::part(border-top-right),
    ::part(border-bottom-left),
    ::part(border-bottom-right) {
      position: absolute;
      width: 20px;
      height: 20px;
    }

    ::part(border-top-left) {
      top: 0;
      left: 0;
    }

    ::part(border-top-right) {
      top: 0;
      right: 0;
    }

    ::part(border-bottom-left) {
      bottom: 0;
      left: 0;
    }

    ::part(border-bottom-right) {
      bottom: 0;
      right: 0;
    }

    ::part(border-top),
    ::part(border-left),
    ::part(border-right),
    ::part(border-bottom) {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }

    ::part(border-top) {
      top: 0;
      left: 20px;
      right: 20px;
      width: auto;
      height: 20px;
    }

    ::part(border-left) {
      top: 20px;
      left: 0;
      bottom: 20px;
      width: 20px;
      height: auto;
    }

    ::part(border-right) {
      top: 20px;
      right: 0;
      bottom: 20px;
      width: 20px;
      height: auto;
    }

    ::part(border-bottom) {
      bottom: 0;
      left: 20px;
      right: 20px;
      width: auto;
      height: 20px;
    }
  `
}
